// Auth state is now managed via HttpOnly cookies (server-side).
// localStorage only holds a non-sensitive "isLoggedIn" flag used for
// client-side routing decisions. The actual JWT never touches localStorage.

const ADMIN_LOGGED_IN_KEY = 'isLoggedIn';
export const AUTH_CHANGED_EVENT = 'auth-token';

const notifyAuthChanged = () => {
  if (typeof window === 'undefined' || typeof window.dispatchEvent !== 'function') return;
  window.dispatchEvent(new window.Event(AUTH_CHANGED_EVENT));
};

export const isAdminLoggedIn = () => {
  try {
    return localStorage.getItem(ADMIN_LOGGED_IN_KEY) === 'true';
  } catch {
    return false;
  }
};

export const setAdminLoggedIn = () => {
  try {
    localStorage.setItem(ADMIN_LOGGED_IN_KEY, 'true');
  } catch {
    // Storage might be unavailable (e.g., privacy mode)
  }
  notifyAuthChanged();
};

export const clearAdminSession = () => {
  try {
    localStorage.removeItem(ADMIN_LOGGED_IN_KEY);
  } catch {
    // Ignore storage errors
  }
  notifyAuthChanged();
};
